import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '../../../helpers';
import {
    task_title_list_json_path
} from '~/routes';

export const useTaskTitleList = () => {
    const {data, isLoading, error} = useQuery({
        queryKey: ['task_title_list_json'],
        queryFn: () => fetchJson(task_title_list_json_path())
    })

    return {data: (data || {}).data || [], isLoading, error}
}
